import config from '@/config'
import urlMap from '@/config/urlMap'

export default function getUrl(url, api = 1, domainType = 1) {
  //api默认为1，请求接口服务； 0 mock服务  1接口服务
  //domainType 默认为1，取apiDomain；可自定义其他域名
  let domain = ''
  if (domainType == 1) {
    domain = config.apiDomain
  } else if (domainType == 2) {
    domain = config.imgDomain
  } else if (domainType == 3) {
    domain = config.assetsUrl
  } else if (domainType == 4) {
    domain = config.factoryUrl
  } else if (domainType == 5) {
    domain = config.basiclawUrl
  } else if (domainType == 6) {
    domain = config.coreUrlAddress
  } else if (domainType == 7) {
    domain = config.train
  } else if (domainType == 8) {
    domain = config.uploadFile
  } else if (domainType == 9) {
    domain = config.TLPayHttp
  }

  return api === 0 ? urlMap[url] : domain + url
}
